module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/coin-purple-966abcbf80a360b9.png"+" 600w",
        images: [{path: __webpack_public_path__ + "assets/images/coin-purple-966abcbf80a360b9.png",width: 600,height: 600}],
        src: __webpack_public_path__ + "assets/images/coin-purple-966abcbf80a360b9.png",
        toString: function(){return __webpack_public_path__ + "assets/images/coin-purple-966abcbf80a360b9.png"},
        
        width: 600,
        height: 600
      }